import React, {Component} from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {showError} from '../../actions/uiActions';
import Validators from '../../utils/Validators';
const TYPES = {
	TEXT: 'text',
	LONG_TEXT: 'long-text',
	NUMBER: 'number',
	DATE: 'date',
	EMAIL: 'email',
	SINGLE_CHOICE: 'single-choice',
	MULTIPLE_CHOICE: 'multiple-choice',
	QUESTION: 'question'
};

const surveyTypes = [
	TYPES.TEXT,
	TYPES.LONG_TEXT,
	TYPES.NUMBER,
	TYPES.DATE,
	TYPES.EMAIL,
	TYPES.SINGLE_CHOICE,
	TYPES.MULTIPLE_CHOICE,
	TYPES.QUESTION
];

class DomainSurveyItem extends Component {
	state = {
		id: '',
		name: '',
		type: '',
		default: '',
		options: '',
		editMode: false,
		pristine: true
	};

	componentDidMount() {
		const {options, ...item} = this.props.item;
		if (item) {
			this.setState({
				editMode: !item.name,
				options: options ? options.map(o => o.name).join(', ') : '',
				...item
			});
		}
	}

	setValue = name => e => this.setState({[name]: e.target.value, pristine: false});

	toggleEditMode = () => this.setState({editMode: !this.state.editMode});

	onSave = () => {
		const {editMode, pristine, options, ...item} = this.state;
		const {id} = this.state;
		const optionsObjs = options.split(',')
		.filter(o => o)
		.map(v => ({
			id: `${id}-${v.trim()}`,
			name: v.trim()
		}));

		if(!this.state.name) {
			this.props.showError("Please enter the question.")
		} else if(this.state.default&&!optionsObjs.find(option=>option.name===this.state.default.trim())) {
			this.props.showError("The default value must be one of the possible options.");
		} else if(this.state.default&&this.state.type===TYPES.DATE&&!Validators.isDate(this.state.default)) {
			this.props.showError("The default value must be a valid date.");
		} else if(this.state.default&&this.state.type===TYPES.EMAIL&&!Validators.isValidEmail(this.state.default)) {
			this.props.showError("The default value must be a valid Email Address.");
		} else if(this.state.default&&this.state.type===TYPES.NUMBER&&!Validators.isInteger(this.state.default)) {
			this.props.showError("The default value must be a valid number.");
		} else if (this.isMultipleChoice()&&optionsObjs.length===0) {
			this.props.showError("You must add at least one option to the question.");
		} else if (this.isMultipleChoice()) {
			if(!this.props.canDelete) {
				this.props.onSave({options: optionsObjs, ...item})
			} else {
				this.props.onEdit({options: optionsObjs, ...item});
			}
			this.setState({options, ...item});
		} else {
			if(!this.props.canDelete) {
				this.props.onSave(item)
			} else {
			this.setState({options: '', ...item});
			this.props.onEdit(item);
			}
		}

		this.toggleEditMode();
	};

	isMultipleChoice = () => this.state.type === TYPES.MULTIPLE_CHOICE|| this.state.type === TYPES.SINGLE_CHOICE;

	disableSaveButton = () => {
		const {name, options} = this.state;
		return !name || this.isMultipleChoice() && !options;
	};

	render() {
		
		const {name, type, options, editMode, pristine} = this.state;

		if (!editMode) {
			return (
				<li className="domain-survey-item">
					<div className="row">
						<div className="col-2">
							<div className="form-group nice">
								<label>Question:</label>
								{name}
							</div>
						</div>
						<div className="col-2">
							<div className="form-group nice">
								<label>Answer Type:</label>
								{type===TYPES.QUESTION?"Yes/No":type}
							</div>
						</div>
						<div className="col-4">
							<div className="form-group nice">
								<label>Options:</label>
								{this.isMultipleChoice() ? options:"DNA"}
							</div>
						</div>
						<div className="col-2">
							<div className="form-group nice">
								<label>Default value:</label>
								{this.state.default}
							</div>
						</div>
					
					<div className="col-2">
					<div className="form-group nice text-center">
					<label>&nbsp;</label>
					<Button onClick={this.toggleEditMode} color="primary">
						Edit
					</Button>
					<Button onClick={() => this.props.delete(this.props.item)} color="primary">
						Delete
					</Button>
					</div>
					</div>
					</div>
				</li>
			);
		}

		return (
			<li className="domain-survey-item edit">
				<div className="row">
					<div className="col-2">
					<div className="form-group nice">
					<label>Question:</label>
					<input type="text"
						required
						value={name}
						placeholder="Question"
						onChange={this.setValue('name')}
						className={`form-control ${!pristine && !name&&'has-error'}`}
					/>
					</div>
					</div>
					<div className="col-2">
					<div className="form-group nice">
					<label>Question type:</label>
						<select className="form-control" value={surveyTypes.includes(type) ? type : surveyTypes[0]}
						onChange={this.setValue('type')}>
							{surveyTypes.map(surveyType => (
							<option
								value={surveyType}
								key={surveyType}
							>
								{surveyType===TYPES.QUESTION?"Yes/No":surveyType}
							</option>
						))}
						</select>
					</div>
				</div>
				
				
					<div className="col-4">
					<div className="form-group nice">
						<label>Options (comma separated):</label>
						{this.isMultipleChoice()? <input type="text"
							required
							value={options}
							placeholder="Options (comma separated)"
							onChange={this.setValue('options')}
							className={`form-control ${!name&&'has-error'}`}
							error={!name}
						/>:"DNA"}
					</div>
					</div>
		
				<div className="col-2">
					<div className="form-group nice">
					<label>Default Value:</label>
					<input type="text"
						required
						value={this.state.default}
						placeholder="Default Value"
						onChange={this.setValue('default')}
						className={`form-control`}
					/>
					</div>
					</div>
				<div className="col-2">
				<div className="form-group nice text-center">
					<label>&nbsp;</label>
					<Button
						disabled={this.disableSaveButton()}
						onClick={this.onSave}
						color="primary">
						Save
					</Button>

					{this.props.canDelete&&<Button onClick={this.toggleEditMode} color="primary">
						Cancel
					</Button>}
				
				</div>
				</div>
				</div>
			</li>
		);
	}
}
DomainSurveyItem.propTypes = {
	delete: PropTypes.func,
	onEdit: PropTypes.func,
	onSave: PropTypes.func,
};

export default connect(null, {showError})(DomainSurveyItem);